import React, { useState } from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';

import { FemaleIcon, MaleIcon } from 'on_web/assets/iconsList';
import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import Question from 'on_web/components/shared/Question/Question';
import UserProfileContext from 'on_web/context/userProfileContext';

import { useTranslation } from 'react-i18next';

function GeneralStep1(props) {
  const context = React.useContext(UserProfileContext);
  const [age, setAge] = useState(
    context && context.userProfile && context.userProfile.year_of_birth
      ? new Date().getFullYear() - context.userProfile.year_of_birth
      : 0
  );
  const [selectedGender, setSelectedGender] = useState(
    context && context.userProfile && context.userProfile.gender
      ? context.userProfile.gender
      : undefined
  );
  const [firstName, setFirstName] = useState(
    context &&
      context.userMetaData &&
      context.userMetaData.user_metadata.firstName
      ? context.userMetaData.user_metadata.firstName
      : undefined
  );
  const minAgeValue = 18;
  const maxAgeValue = 99;

  const { t } = useTranslation();

  const onClickNext = () => {
    const userProfile = context ? context.userProfile : null;
    const userMetadata = context ? context.userMetaData.user_metadata : null;

    if (props.onClickNext && userProfile && userMetadata) {
      userProfile.year_of_birth = new Date().getFullYear() - age;
      userProfile.gender = selectedGender === '1' ? 'female' : 'male';
      userMetadata.firstName = firstName;
      props.onClickNext(userMetadata, userProfile);
    }
  };

  const questions = [
    {
      icon: <FemaleIcon height={'66px'} />,
      label: t('onboarding.generalSection.generalStep1.question1'),
      checked: selectedGender === 'female',
      value: '1',
    },
    {
      icon: <MaleIcon height={'66px'} />,
      label: t('onboarding.generalSection.generalStep1.question2'),
      checked: selectedGender === 'male',
      value: '2',
    },
  ];

  return (
    <React.Fragment>
      <Header />
      {context && context.forPce ? (
        <PceStepProgressIndicator selectedSlideIx={1} firstStep />
      ) : (
        (context == null || context.editMode !== true) && (
          <StepProgressIndicator
            showBasicQuestions={context.showBasicQuestions}
            selectedSlideIx={
              process.env.REACT_APP_HIDE_DNA_SECTION !== 'true' ? 1 : 0
            }
            firstStep
          />
        )
      )}

      <Question
        sectionTitle={t('onboarding.generalSection.generalStep1.sectionTitle1')}
        textInput={true}
        textValue={firstName}
        onAnswer={val => setFirstName(val)}
        autoFocus
      />

      <Question
        sectionTitle={t('onboarding.generalSection.generalStep1.sectionTitle2')}
        numericalInputValue={age}
        numericalInputValueMin={minAgeValue}
        numericalInputValueMax={maxAgeValue}
        numericalInputValueValidationMsg={t(
          'onboarding.generalSection.generalStep1.minAgeMessage'
        )}
        min
        onAnswer={val => setAge(val)}
      />

      <Question
        sectionTitle={t('onboarding.generalSection.generalStep1.sectionTitle3')}
        instructionAbove={t(
          'onboarding.generalSection.generalStep1.biologicalSexInstructions'
        )}
        radioSelectionWithIcon={{ items: questions, twoColumns: true }}
        onAnswer={val => {
          setSelectedGender(val);
        }}
      />

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={props.onClickBack}
        nextButtonDisabled={
          age < minAgeValue ||
          age > maxAgeValue ||
          selectedGender == null ||
          firstName == null ||
          firstName === ''
        }
        editMode={context && context.editMode}
      />
    </React.Fragment>
  );
}

export default GeneralStep1;
